import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-education-primary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/k12/404",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "us-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.com/k12/contact/",
                    lang: "en"
                },
                eloquaPage: "webpage",
                ...pageFooter({ strings })
            };
        case "us-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "us-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "us-education-primary-home":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "K-12 Online Language Learning | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone online language learning for education complements classroom instruction in both English and world languages. Learn about customer successes.",
                    canonical_url: "https://www.rosettastone.com/k12/",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            data_qa: "Section 1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Language connects us all, laying the groundwork for learning and growth. For an increasingly diverse student population, language can also be the key to achievement, in school and beyond. "
                                    },
                                    direction: "image-right",
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    title: {
                                        align: "left",
                                        content: "Where will language take your students?",
                                        heading: "h1",
                                        type: "page-title",
                                        theme: "black"
                                    },
                                    video: {
                                        play_button: {
                                            label: "Learn More"
                                        },
                                        source: "https://www.youtube.com/embed/-tCgOKqR0mo",
                                        thumbnail: {
                                            asset_fixed: null,
                                            asset_fluid: null,
                                            asset_static: null,
                                            height: "100%",
                                            width: "100%"
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            visible: true,
                            data_qa: "Section 2 - Image Text",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "As communities diversify and global connections increase, the need for K–12 students to develop language skills grows. Compared to children who speak only one language, bilingual students benefit from better working memories, greater mental flexibility, and the ability to more easily grasp abstract concepts."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Promoting the power of bilingualism",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        content: "Promoting the power of bilingualism",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Every student is different. That’s why our programs personalize language learning through the Adaptive Blended Learning Model, while incorporating scaffolded instruction and Speech Recognition Engine technology. Individualized learning paths empower students to take ownership of their own language development."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        alt: "Addressing individual needs for language learning",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Addressing individual needs for language learning",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Speaking with purposeful repetition and listening practice is a key attribute of our solutions, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Advancing proficiency with immediate feedback",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Advancing proficiency with immediate feedback",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "We support, engage, and encourage students throughout their learning journeys by using pedagogies that respect a diversity of cultures and languages. Our programs and lessons are designed to celebrate student achievement every step of the way."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        alt: "Culturally respectful for more inclusive classrooms",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Culturally respectful for more inclusive classrooms",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "We empower educators to enhance academic outcomes with programs aligned with multiple language proficiency standards. And we combine language learning with subject knowledge to support career readiness, while helping administrators meet district and state goals."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Improving student outcomes for greater academic achievement",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Improving student outcomes for greater academic achievement",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Students can learn anywhere. Our language learning solutions enable both students and educators to access language lessons and activities virtually. That way, any moment can become a teachable one."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        alt: "Opportunities for learning anywhere, anytime",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Opportunities for learning anywhere, anytime",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ]
                        },
                        {
                            visible: true,
                            data_qa: "Section 3 - Contact",
                            layout: "list",
                            panels: [
                                {
                                    data_qa: null,
                                    sub_title: {
                                        align: "center",
                                        content:
                                            "Please fill out the form below and we'll follow up with you right away.",
                                        theme: "white",
                                        type: "sub-title"
                                    },
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    title: {
                                        align: "center",
                                        content: "Get the language learning support you need. Connect with us today.",
                                        heading: "h2",
                                        theme: "white",
                                        type: "section-title"
                                    }
                                }
                            ]
                        }
                    ]
                }
            };
        case "us-education-primary-solutions-K12-english-language":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Language Training Solutions | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
                    canonical_url: "https://www.rosettastone.com/k12/solutions/K12-english-language",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Rosetta Stone Foundations is a scalable e-learning solution designed for beginner to intermediate students to build fundamental English language skills. Students develop their skills through learning activities, stories, and live online conversations."
                                    },
                                    direction: "image-right",
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    title: {
                                        align: "left",
                                        content: "Lay the groundwork for success with Rosetta Stone® Foundations",
                                        heading: "h1",
                                        type: "page-title",
                                        theme: "black"
                                    },
                                    video: {
                                        play_button: {
                                            label: "Watch the Video"
                                        },
                                        source: "https://www.youtube.com/embed/tGA3XaoVCcY",
                                        thumbnail: {
                                            asset_fixed: null,
                                            asset_fluid: null,
                                            asset_static: null,
                                            height: "100%",
                                            width: "100%"
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "For your emergent bilingual students, or English language learners, in grades 7–12, producing spoken language is key. You need an immersive solution that allows students to build their language skills naturally, accelerating speaking confidence."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Building skills for conversational proficiency",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Building skills for conversational proficiency",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        alt: "Speech Recognition Engine with immediate feedback",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Speech Recognition Engine with immediate feedback",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "With live tutoring, students can talk with native speakers in a safe, controlled online environment. Meanwhile, teachers receive support materials, including workbooks, guides, and quizzes, as well as reports that can assist in class planning and one-on-one instruction."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Support for students and educators every step of the way",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Support for students and educators every step of the way",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "See the greater gains in year-over-year AZELLA scores for English language learners."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        alt: "Rosetta Stone Foundations gets results",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Rosetta Stone Foundations gets results",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Access these additional resources to learn more about Rosetta Stone Foundations."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        alt: "Build a strong foundation",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Build a strong foundation",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "5",
                            layout: "list",
                            panels: [
                                {
                                    data_qa: null,
                                    sub_title: {
                                        align: "center",
                                        content:
                                            "Please fill out the form below and we'll follow up with you right away.",
                                        theme: "white",
                                        type: "sub-title"
                                    },
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    title: {
                                        align: "center",
                                        content: "Get the language learning support you need. Connect with us today.",
                                        heading: "h2",
                                        theme: "white",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "6",
                            layout: "carousel",
                            panels: [
                                {
                                    quote:
                                        "Rosetta Stone English meets my students’ needs by allowing them to practice and get immediate feedback in a safe setting. When students are struggling, the lessons are terrific.",
                                    attribution:
                                        "Mary Doerr, ESL Specialist at Lincoln Elementary, Wenatchee Public Schools, WA"
                                },
                                {
                                    quote:
                                        "Students were surprised to see such a diversity of characters they could select. They can relate to the characters, yet it’s interesting to see they are choosing characters of different backgrounds—not just their own.",
                                    attribution:
                                        "Caitlin McHugh, Director of English as a Second Language, Boston Collegiate Charter School, MA"
                                },
                                {
                                    quote:
                                        "I would definitely recommend Rosetta Stone English to other educators! We’ve been searching for ways to provide more engaging, targeted lessons to our English learners, and I believe Rosetta Stone English achieves that.",
                                    attribution: "Courtney Bradley, Culture and Data Coordinator, Soleil Academy, CA"
                                }
                            ],
                            title: {
                                align: "center",
                                content: "Trusted for 25+ years by schools nationwide.",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: true
                        }
                    ]
                }
            };
        case "us-education-primary-solutions-world-languages":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Language Training Solutions | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
                    canonical_url: "https://www.rosettastone.com/k12/solutions/elementary-english-language",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            dataQa: "1",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "The Rosetta Stone Foundations for World Languages K–12 solution provides a range of language instruction, incorporating speaking, listening, grammar, and writing lessons. The program allows for flexibility and personalized study, enabling students to learn at their own pace."
                                    },
                                    dataQa: "1",
                                    direction: "image-right",
                                    image: {
                                        alt:
                                            "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "100%",
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content:
                                            "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Today, more of the world’s population is bilingual than monolingual, and the demand for bilingual workers is rising. Your students need a learning solution that can help them develop speaking and listening skills in a wide range of languages, for greater success in school and beyond."
                                    },
                                    dataQa: "2",
                                    direction: "image-left",
                                    image: {
                                        alt: "Meeting a range of diverse language learning needs",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "80%",
                                        asset_static: null,
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Meeting a range of diverse language learning needs",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
                                    },
                                    dataQa: "3",
                                    direction: "image-right",
                                    image: {
                                        alt: "Immersing students in language so they’re prepared to speak",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "80%",
                                        asset_static: null,
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Immersing students in language so they’re prepared to speak",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Students build confidence by practicing their conversational skills under the direction of one of our experienced live tutors, a native speaker of the language being studied. Each session takes place in a real-time group setting with other students for even more opportunities to converse. Students also have access to children’s stories, history, and cultural resources."
                                    },
                                    dataQa: "4",
                                    direction: "image-left",
                                    image: {
                                        alt: "Creating opportunities for more speaking and listening practice",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "80%",
                                        asset_static: null,
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Creating opportunities for more speaking and listening practice",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Extensive, repetitive speaking and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
                                    },
                                    dataQa: "5",
                                    direction: "image-right",
                                    image: {
                                        alt: "Speech Recognition Engine with immediate feedback",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Speech Recognition Engine with immediate feedback",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Access these additional resources to learn more about Rosetta Stone World Languages."
                                    },
                                    image: {
                                        alt: "Provide a world of opportunities",
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        height: "80%",
                                        asset_static: null,
                                        width: "80%"
                                    },
                                    dataQa: "6",
                                    direction: "image-left",
                                    title: {
                                        content: "Provide a world of opportunities",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 5 - Contact",
                            visible: true,
                            layout: "list",
                            panels: [
                                {
                                    data_qa: null,
                                    sub_title: {
                                        content:
                                            "Please fill out the form below and we'll follow up with you right away.",
                                        theme: "white",
                                        align: "center",
                                        type: "sub-title"
                                    },
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    title: {
                                        align: "center",
                                        content: "Get the language learning support you need. Connect with us today.",
                                        heading: "h2",
                                        theme: "white",
                                        type: "section-title"
                                    }
                                }
                            ]
                        },
                        {
                            data_qa: "Section 6 - Quotes",
                            visible: true,
                            layout: "carousel",
                            title: {
                                align: "center",
                                content: "Trusted for 25+ years by schools nationwide.",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },

                            panels: [
                                {
                                    quote:
                                        "Rosetta Stone English meets my students’ needs by allowing them to practice and get immediate feedback in a safe setting. When students are struggling, the lessons are terrific.",
                                    attribution:
                                        "Mary Doerr, ESL Specialist at Lincoln Elementary, Wenatchee Public Schools, WA"
                                },
                                {
                                    quote:
                                        "Students were surprised to see such a diversity of characters they could select. They can relate to the characters, yet it’s interesting to see they are choosing characters of different backgrounds—not just their own.",
                                    attribution:
                                        "Caitlin McHugh, Director of English as a Second Language, Boston Collegiate Charter School, MA"
                                },
                                {
                                    quote:
                                        "I would definitely recommend Rosetta Stone English to other educators! We’ve been searching for ways to provide more engaging, targeted lessons to our English learners, and I believe Rosetta Stone English achieves that.",
                                    attribution: "Courtney Bradley, Culture and Data Coordinator, Soleil Academy, CA"
                                }
                            ]
                        }
                    ]
                }
            };
        default:
            return null;
    }
};
